import { openNewbuildingBookingConfirm } from './actions';
import { IThunkActionCreator } from '../../store';

export const openNewbuildingBookedFromDeveloperConfirmAction = (): IThunkActionCreator => {
  return async (dispatch, getState, { logger }) => {
    dispatch(openNewbuildingBookingConfirm());
  };
};
